import { MRT_ColumnDef } from 'material-react-table';
import { useFilterSelectOptions, TERMINAL_STATUS_COLOR } from './status';
import NameCellWithImage, { ChipCell } from 'components/controls/image-cell';
import { useWorkspace } from 'hooks/useWorkspace';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { ToolTip } from 'components/controls';

export type TerminalsColumns = {
    id: string;
    name: string;
    status: string;
    deviceType: string;
    deviceId: string;
    createdAt: string;
    accountId: string;
};

export const useTerminalTableColumns = (): MRT_ColumnDef<TerminalsColumns>[] => {
    const { t } = useTranslation();
    const { baseWorkspaceUrl } = useWorkspace();
    const filterSelectOptions = useFilterSelectOptions();

    return useMemo(
        () => [
            {
                accessorKey: 'name',
                header: t('TABLE_HEADERS.NAME'),
                size: 400,
                Cell: ({ cell }) => {
                    const path = `${baseWorkspaceUrl}/terminal/${cell.row.original.id}`;
                    return (
                        <ToolTip
                            disableHoverListener={cell.row.original['name'].length < 45}
                            title={cell.getValue<string>()}
                            placement="top-end"
                        >
                            <NameCellWithImage
                                cell={cell}
                                defaultImage={'/tablet.jpeg'}
                                isLink
                                path={path}
                                target="_self"
                            />
                        </ToolTip>
                    );
                },
                enableColumnActions: false,
            },
            {
                accessorKey: 'deviceId',
                header: t('TABLE_HEADERS.DEVICE_ID'),
                size: 170,
                enableColumnActions: false,
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'status',
                header: t('TABLE_HEADERS.STATUS'),
                filterVariant: 'select',
                filterSelectOptions: filterSelectOptions,
                enableColumnActions: false,
                size: 150,
                Cell: ({ cell }) => (
                    <ChipCell
                        value={cell.getValue<string>()}
                        statusColorMap={TERMINAL_STATUS_COLOR}
                        translationKey="STATUS"
                    />
                ),
            },
            {
                id: 'accountId',
                accessorKey: 'accountEmail',
                header: t('TABLE_HEADERS.CONNECTED_ACCOUNT'),
                filterVariant: 'autocomplete',
                filterSelectOptions: [],
                size: 200,
                enableColumnActions: false,
                enableSorting: false,
            },
            {
                accessorKey: 'createdAt',
                header: t('TABLE_HEADERS.CREATION_DATE'),
                size: 100,
                enableColumnActions: false,
                enableColumnFilter: false,
            },
        ],
        [t, baseWorkspaceUrl, filterSelectOptions],
    );
};
